/**
 * Adresse du tableau de bord qui va avec le site lu.
 *
 * Le site de test (sandbox.donoor.org) doit mener au tableau de bord de test
 * (dashboard-sandbox.donoor.org) : sinon « Inscrire mon association » ou
 * « Connexion » y créaient un VRAI compte sur dashboard.donoor.org (Karim
 * 2026-10-22). Partout ailleurs (prod, staging, local) : la vraie adresse,
 * comme avant.
 */
const DASHBOARD_PROD = "https://dashboard.donoor.org";
const DASHBOARD_SANDBOX = "https://dashboard-sandbox.donoor.org";

export function adresseDashboard(hostname: string | undefined | null): string {
  return hostname === "sandbox.donoor.org" ? DASHBOARD_SANDBOX : DASHBOARD_PROD;
}
